import { useContext } from 'react'

import { AppContext } from '../../stores/App/AppStore'
import { ActionTypes } from '../../stores/App/AppReducer'
import { GiftSubscriptionLandingPage } from '../../types/GiftSubscriptionLandingPage'

import GiftSubscriptionRepository from "./gift.repository"

const useGiftRepository = () => {
    const { dispatch } = useContext(AppContext)
    const giftSubscriptionRepository = new GiftSubscriptionRepository()

    const retrieveGiftSubscriptionLandingPage = async () => {
        return giftSubscriptionRepository.retrieveGiftSubscriptionLandingPage()
            .then((giftSubscriptionLanding: GiftSubscriptionLandingPage) => {
                dispatch({
                    type: ActionTypes.GIFT_SUBSCRIPTION_LANDING_PAGE_RETRIEVED,
                    data: giftSubscriptionLanding,
                })
            })
            .catch((error) => {
                console.error(error.message)
            })
    }

    return {
        retrieveGiftSubscriptionLandingPage,
    }
}

export { useGiftRepository }